/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type { CreateManualRequestErrorResponse, CreateManualRequestResponse } from './api.schemas';

import { api } from '../util/http';

export const createEncountersIdentityVerificationManualRequest = (
  encounterId: number,
  signal?: AbortSignal,
) => {
  return api<CreateManualRequestResponse>({
    url: `/api/encounters/${encounterId}/identity-verification/manual-request`,
    method: 'POST',
    signal,
  });
};

export const getCreateEncountersIdentityVerificationManualRequestMutationOptions = <
  TError = CreateManualRequestErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createEncountersIdentityVerificationManualRequest>>,
    TError,
    { encounterId: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createEncountersIdentityVerificationManualRequest>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationKey = ['createEncountersIdentityVerificationManualRequest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createEncountersIdentityVerificationManualRequest>>,
    { encounterId: number }
  > = (props) => {
    const { encounterId } = props ?? {};

    return createEncountersIdentityVerificationManualRequest(encounterId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateEncountersIdentityVerificationManualRequestMutationResult = NonNullable<
  Awaited<ReturnType<typeof createEncountersIdentityVerificationManualRequest>>
>;

export type CreateEncountersIdentityVerificationManualRequestMutationError =
  CreateManualRequestErrorResponse;

export const useCreateEncountersIdentityVerificationManualRequest = <
  TError = CreateManualRequestErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createEncountersIdentityVerificationManualRequest>>,
      TError,
      { encounterId: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createEncountersIdentityVerificationManualRequest>>,
  TError,
  { encounterId: number },
  TContext
> => {
  const mutationOptions =
    getCreateEncountersIdentityVerificationManualRequestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
